// extracted by mini-css-extract-plugin
export default {"addNewEmail":"addNewEmail--NpZVR","errorMessage":"errorMessage--AeY5b form-group__error"};